import {
  ILoginSSOResponse,
} from '../../login/dto/login-response.interface';

// Modle dieu huong dang nhap sso luong web binh thuong
export class AuthModelSSO {
  authorization_code!: string | undefined;
  accessToken!: string | undefined;
  redirect_uri!: string | undefined;

  mapDataFromAPI(args: any) {
    this.authorization_code = args?.authorization_code ?? '';
    this.redirect_uri = args?.redirect_uri ?? '';
    // this.accessToken = args?.accessToken ?? '';
    this.accessToken = args?.token ?? '';
    return this;
  }
}
